import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGooglePlay$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePlay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '80fda36920e0d91265bf3f9566f0bb361579f4ab', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'aede359e39521371433157271ff2f61319a0b54e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7548dd7e72911520043b9e93c977212e2f9d9cab', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.417 18.438c-.257-.072-.425-.334-.425-.74V4.284c0-.376.142-.63.367-.723l6.42 7.475zm.884-.285 7.726-4.497-1.881-2.19zm7.78-9.795L6.462 3.924l5.695 6.673zm.516.301 2.985 1.737c.565.33.57.86 0 1.192l-3.06 1.78-1.996-2.338z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google-play", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-play"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-play":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePlay$1);
            }
            break;
    } });
}

const CosmosIconGooglePlay = CosmosIconGooglePlay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePlay, defineCustomElement };
